import {FormStyle, getLocaleDayNames, getLocaleMonthNames, TranslationWidth} from '@angular/common';
import {Inject, LOCALE_ID} from '@angular/core';
import {NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';

export class NgbDatepickerI18nCustomService extends NgbDatepickerI18n {
  private weekdaysShort: Array<string>;
  private monthsShort: Array<string>;
  private monthsFull: Array<string>;
  constructor(@Inject(LOCALE_ID) locale: string) {
    super();
    const weekdaysStartingOnSunday = getLocaleDayNames(locale, FormStyle.Format, TranslationWidth.Narrow);
    this.weekdaysShort = weekdaysStartingOnSunday.map((day, index) => weekdaysStartingOnSunday[(index + 1) % 7]);
    this.monthsShort = getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Abbreviated);
    this.monthsFull = getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Wide);
  }
  getWeekdayShortName(weekday: number): string {
    return this.weekdaysShort[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return this.monthsShort[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.monthsFull[month - 1];
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/service/datepicker-i18n-custom.service.ts